module.exports = __webpack_public_path__ + "static/profile-0c35d781517882e629fad2c10396a50e.png";